import { Grid, Typography } from '@mui/material';
import React from 'react';
import { type Slide } from '../../_data';
import { EditableField } from '../../components/EditableField';
import { getSlideField } from '../../utils';
import { usePostCalculateFees } from 'pages/Cases/hooks/usePostCalculateFees';
import ModelSetsFeesTable from 'pages/Cases/components/ModelSetsFeesTable';
export type Slide7_1ContentType = [
  {
    field: 'title';
    label: string;
    value: string;
    type: 'text';
  },
  {
    field: 'modelSet';
    label: string;
    value: string;
    type: 'modelSet';
  },
];

export const Slide7_1Content = React.memo(
  ({
    slide,
    onChangeSlide,
  }: {
    slide: Slide<Slide7_1ContentType>;
    onChangeSlide: (
      slide: Slide<Slide7_1ContentType>,
      content: Slide7_1ContentType,
    ) => void;
  }): React.ReactElement => {
    const slideField = getSlideField(slide, 'modelSet')?.value;
    const createModelSetHolding = () => {
      return {
        model_set_name: slideField.model_set_name,
        portfolio_options: slideField.portfolio_options.map(option => ({
          option: option.option || 1,
          portfolios: option.portfolios.map(portfolio => ({
            portfolio_name: portfolio.portfolio_name,
            risk_profile: portfolio.risk_profile,
            holdings: portfolio.holdings.map(holding => ({
              model_id: holding.model_id,
              weight: holding.weight,
            })),
          })),
        })),
      };
    };

    const { fees, isFeesLoading } = usePostCalculateFees({
      enabled: !!slide,
      body: createModelSetHolding(),
    });
    return (
      <Grid
        container
        direction="row"
        sx={{
          padding: '12px 12px 0 12px',
          height: '100%',
          width: '100%',
        }}
      >
        <Grid
          container
          direction="row"
          sx={{
            width: '100%',
            height: 'calc(100% - 142px)',
            overflowY: 'auto',
            overflowX: 'hidden',
          }}
        >
          <Grid
            item
            xs={12}
            sx={{
              textAlign: 'left',
              fontFamily: 'Roboto',
              fontSize: '24px',
              fontWeight: 'bold',
              color: '#004F7E',
            }}
          >
            <EditableField
              field="title"
              slide={slide}
              onSlideContentChange={onChangeSlide}
            />
            <div style={{ marginBottom: '12px', marginTop: '30px' }}>
              {fees && !isFeesLoading && <ModelSetsFeesTable fees={fees} />}
            </div>
          </Grid>
        </Grid>

        <Grid item xs={12} pt={1} minHeight={480}>
          <Typography
            sx={{
              fontSize: '12px',
              color: '#7D7D7D',
              fontWeight: '400',
              marginLeft: '12px',
              marginTop: '12px',
              marginBottom: '12px',
              fontFamily: 'roboto',
            }}
          >
            * Based on stated maximum fees – may be lower based on any advisor
            exceptions or breakpoints AssetMark US/Global Market Blend is the
            default option for Core exposure in cases where an adviser has
            identified cost as a factor in the decision-making process and to
            the extent that an adviser is not seeking tactical,
            actively-managed, factor-based or socially-focused Core exposure.
            The consideration of AssetMark proprietary strategies, including
            strategies managed by AssetMark, during the investment consulting
            process creates a conflict of interest for AssetMark as AssetMark
            receives fees for the management of those strategies and funds.
          </Typography>
        </Grid>
      </Grid>
    );
  },
);

export default Slide7_1Content;
